import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

const A = ({ href = "", children }) =>
  href.startsWith("/") ? <Link to={href}>{children}</Link> : <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;

export default function Markdown({ children, className = "" }) {
  return (
    <div className={`prose-sp ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: A, img: ({ src, alt }) => <img src={fileUrl(src)} alt={alt || ""} loading="lazy" /> }}>
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
